import Input, { Input as InputBaseComponent } from "./Input";
export default Input;
export { InputBaseComponent };
